/**
 * @fileoverview GET handler for the "/integrations/currents_integration_data/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsCurrentsIntegrationDataId } from "./constants";
import type { IntegrationsCurrentsIntegrationDataIdResult } from "./types";
import { isIntegrationsCurrentsIntegrationDataIdResult } from "./validators";

export const getIntegrationsCurrentsIntegrationDataId = reactQueryFetcherAdapter(
  integrationsCurrentsIntegrationDataId,
  (signal: AbortSignal, id: string): Promise<IntegrationsCurrentsIntegrationDataIdResult> => {
    return fetch(`/integrations/currents_integration_data/${id}`, "GET", {}, { signal });
  },
  isIntegrationsCurrentsIntegrationDataIdResult
);
